import { YOO_FINDS_CDN } from "@/common";

export const PRODUCT_APP_QR_CODE = `${YOO_FINDS_CDN}/pc/app_qrcode_v1.png`;
